module.exports = __webpack_public_path__ + "static/media/Minccino_gaussian2.3005bf1b.png";